import { Lightning } from '../icons';

const Logo = () => (
  <p className="flex items-center">
    <Lightning className="w-10 h-10 mr-1 flex-shrink-0" />
    <span className="text-xl font-semibold tracking-wider whitespace-nowrap">
      Jumpstart React
    </span>
  </p>
);

export default Logo;
